/** @jsxImportSource @emotion/react */
import { TableRow } from "../../../components/table-components/TableRow";
import { TableCellLink } from "../../../components/table-components/TableCellLink";
import { PreviewReportType } from "../Reports";
import { routes } from "../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { StyledText } from "../../../assets/typography/typography";
import { SmallBadge } from "../../../components/SmallBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { colors } from "../../../components/colors";
import { useState } from "react";
import { css } from "@emotion/react";
type Props = {
  report: PreviewReportType;
};

const lastTableCellContentStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${colors.textPrimary};
  cursor: pointer;
`;

const lastTableCellStyle = css`
  display: flex;
  padding-right: 24px;
  justify-content: end;
  align-items: center;
`;

export const ReportsLinkTableRow = ({ report }: Props) => {
  const [showDetailsIsVisible, setShowDetailsIsVisible] = useState(false);
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const href = routes.reportDetails(
    report.reportApiUrlKey,
    organizationKeyName
  );

  return (
    <TableRow
      onMouseEnter={() => setShowDetailsIsVisible(true)}
      onMouseLeave={() => setShowDetailsIsVisible(false)}
    >
      <TableCellLink className="pl-5" href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {report.title}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {report.description}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <SmallBadge>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {report.category}
          </StyledText>
        </SmallBadge>
      </TableCellLink>
      <TableCellLink css={lastTableCellStyle} href={href}>
        {showDetailsIsVisible && (
          <div css={lastTableCellContentStyle}>
            <StyledText
              className="bodyTextRegular mb-0"
              color={colors.textPrimary}
            >
              See details
            </StyledText>
            <StyledText
              className="bodyTextRegular mb-0"
              color={colors.textPrimary}
            >
              <FontAwesomeIcon icon={solid("arrow-right")} />
            </StyledText>
          </div>
        )}
      </TableCellLink>
    </TableRow>
  );
};
